import type { ProductCatalogType as ProductCatalogTypeEnum } from '@/lib/api/api.gen'

/** `App\Enums\ProductCatalogType`: subscription packages sell recurring deliveries. */
export const ProductCatalogType = {
  Standard: 'standard',
  SubscriptionPackage: 'subscription_package',
} as const satisfies Record<string, ProductCatalogTypeEnum>

export type ProductCatalogTypeValue = (typeof ProductCatalogType)[keyof typeof ProductCatalogType]

export function isSubscriptionPackage(
  product: { product_catalog_type?: string | null } | null | undefined
): boolean {
  return product?.product_catalog_type === ProductCatalogType.SubscriptionPackage
}
